import { useTranslation } from "react-i18next";

import styles from "./styles.module.css";
import React, { useState } from "react";
import WeightReportsTable from "@/components/organisms/WeightReportsTable";
import { DEFAULT_WEIGHT_REPORTS_COLUMN } from "@/components/organisms/WeightReportsTable/const/default";
import { UploadWeightReportModal } from "@/components/organisms/UploadWeightReportModal";
import { SubHeader } from "@/components/molecules/SubHeader";

export default function MatchWeightReports() {
  const [open, setOpen] = useState<boolean>(false);
  const { t } = useTranslation();

  return (
    <>
      <title>{`Reviver - ${t("weightReports:weightReports")}`}</title>
      <meta name="description" content="Reviver" />
      <SubHeader
        title={t("weightReports:weightReports")}
        onAction={() => setOpen(true)}
        actionLabel={t("weightReports:uploadWeightReport")}
      />
      <div className={styles.matchWeightReportsRoot}>
        <div className={styles.matchWeightReportsContent}>
          <WeightReportsTable visibleColumns={DEFAULT_WEIGHT_REPORTS_COLUMN} actionable={true} />
        </div>
      </div>
      <UploadWeightReportModal open={open} setOpen={setOpen} />
    </>
  );
}
